const Textarea = ({
  label,
  value,
  onChange,
  rows = 3,
  placeholder = "",
  className = "",
  helperText = "", // ✅ new prop
}) => {
  return (
    <div>
      {label && (
        <label className="text-sm font-medium text-black">{label}</label>
      )}
      <textarea
        rows={rows}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`w-full mt-1 px-3 py-2 text-sm border rounded-md bg-white border-gray-300 focus:outline-none resize-none ${className}`}
      />
      {helperText && (
        <p className="mt-1 text-sm font-semibold text-red">{helperText}</p>
      )}
    </div>
  );
};

export default Textarea;
